import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { productService } from '../services/productService';
import { UpdateProductDto } from '../types/product';

export const useProducts = () => {
  const queryClient = useQueryClient();

  const getProducts = useQuery({
    queryKey: ['products'],
    queryFn: productService.getProducts,
  });

  const createProduct = useMutation({
    mutationFn: productService.createProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });

  const updateProduct = useMutation({
    mutationFn: ({ code, data }: { code: string; data: UpdateProductDto }) => 
      productService.updateProduct(code, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });

  const deleteProduct = useMutation({
    mutationFn: productService.deleteProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });

  return {
    products: getProducts.data || [],
    isLoading: getProducts.isLoading,
    isError: getProducts.isError,
    error: getProducts.error,
    createProduct,
    updateProduct,
    deleteProduct,
  };
}; 